import { passwordStrength } from 'check-password-strength';
import { z } from 'zod';

export enum PasswordStrength {
  TooWeak,
  Weak,
  Medium,
  Strong,
}
interface IPasswordStrengthResult {
  id: PasswordStrength;
  value: string;
  length: number;
}
// TODO: Switch to zxcvbn for password strength
export const getPasswordStrength = (password: string): IPasswordStrengthResult => {
  if (!passwordValidationSchema.safeParse(password).success) {
    return {
      id: PasswordStrength.TooWeak,
      value: 'Too weak',
      length: password.length,
    };
  }
  return passwordStrength(password);
};

export const passwordValidationSchema = z
  .string()
  .min(8)
  .regex(/[A-Z]/)
  .regex(/[a-z]/)
  .regex(/[0-9]/);

// Export the type for TypeScript consumers
export type PasswordValidationType = z.infer<typeof passwordValidationSchema>;
